import './card.scss'

const Card = props => {
	const { classes = '', bgWhite, pink, onClick, children, forwardedRef, style = {} } = props

	return (
		<div
			className={`
        card 
        ${classes} 
        ${bgWhite ? 'white' : ''}
        ${pink ? 'pink' : ''}
      `}
			style={style}
			onClick={onClick || null}
			ref={forwardedRef || null}
		>
			{children}
		</div>
	)
}

export default Card
